import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

export const FooterColumn = forwardRef((props, ref) => {
  const { as = 'div', children, ...rest } = props

  const Comp = as

  return (
    <Comp className="dev_dash__footer-column" ref={ref} {...rest}>
      {children}
    </Comp>
  )
})

FooterColumn.displayName = 'FooterColumn'

FooterColumn.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
}
